<template>
	<div class="swiper-slide">
		<slot />
	</div>
</template>
